export const config = {
  baseURLApi: process.env.REACT_APP_API_ENDPOINT,
  isWebView: process.env.REACT_APP_IS_WEB_VIEW,
};